var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8889 0H1.11111C0.497461 0 0 0.497461 0 1.11111V18.8889C0 19.5025 0.497461 20 1.11111 20H18.8889C19.5025 20 20 19.5025 20 18.8889V1.11111C20 0.497461 19.5025 0 18.8889 0Z",
    fill: "#117EB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64963 7.73649H6.32268V16.337H3.64963V7.73649ZM4.98657 3.46122C5.84129 3.46122 6.53574 4.15566 6.53574 5.01038C6.53574 5.86594 5.84129 6.56066 4.98657 6.56066C4.78059 6.56456 4.5759 6.52736 4.38446 6.45123C4.19302 6.3751 4.01868 6.26157 3.87163 6.11728C3.72459 5.97299 3.60778 5.80083 3.52804 5.61087C3.4483 5.42091 3.40723 5.21696 3.40723 5.01094C3.40723 4.80492 3.4483 4.60097 3.52804 4.41101C3.60778 4.22105 3.72459 4.04889 3.87163 3.9046C4.01868 3.7603 4.19302 3.64678 4.38446 3.57065C4.5759 3.49452 4.78059 3.45732 4.98657 3.46122ZM7.99935 7.73622H10.5632V8.91149H10.5988C10.9557 8.23538 11.8277 7.5226 13.128 7.5226C15.8346 7.5226 16.3346 9.30399 16.3346 11.6198V16.337H13.6632V12.1545C13.6632 11.1573 13.6449 9.87427 12.2743 9.87427C10.8835 9.87427 10.6699 10.9607 10.6699 12.0826V16.337H7.99907V7.73649L7.99935 7.73622Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c2896a33c7d41b663a7a6f3697492983.svg";
export { ForwardRef as ReactComponent };